import React from 'react';
import Payment from './Payment';

const PaymentSuccess = () => {
  return <Payment />;
};

export default PaymentSuccess;